import { ProxyClient } from './client/ProxyClient';

export const subscribeNewsUser = async (params: { email?: string }) => {
  const { data } = await ProxyClient.post('/user/subscribe/', { params });
  return data;
};
